import { render, staticRenderFns } from "./SignCheck.vue?vue&type=template&id=c65506be&scoped=true&"
import script from "./SignCheck.vue?vue&type=script&lang=js&"
export * from "./SignCheck.vue?vue&type=script&lang=js&"
import style0 from "./SignCheck.vue?vue&type=style&index=0&id=c65506be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c65506be",
  null
  
)

export default component.exports